import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiplerefs',
  standalone: false,
})
export class CitationDeleteMultipleRefsPipe implements PipeTransform {
  citationCount: string[] = [];
  transform(desc: string, multipleRefsToDelete) {
    if (
      desc.includes('{{totalCitationRefCountPlaceholder}}') &&
      desc.includes('{{dataCitationCount}}') &&
      multipleRefsToDelete &&
      multipleRefsToDelete.citationsTotalCount
    ) {
      return desc
        .replace(
          '{{totalCitationRefCountPlaceholder}}',
          multipleRefsToDelete.citationsTotalCount.toString()
        )
        .replace('{{dataCitationCount}}', multipleRefsToDelete.citationCount);
    }
    return desc;
  }
}
